var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemNumberIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.873,
    height: 16.526,
    viewBox: "0 0 14.873 16.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1298",
    style: {
      stroke: "#577596",
      strokeMiterlimit: 10,
      fill: "#fff",
      strokeLinecap: "square"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.873,
    height: 16.526,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13.873,
    height: 15.526,
    rx: 1.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 33",
    transform: "translate(3.099 4.452)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#577596",
      strokeMiterlimit: 10
    },
    d: "M0 0h9.064"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 34",
    transform: "translate(2.75 7.219)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#577596",
      strokeMiterlimit: 10
    },
    d: "M0 0h5.577"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 35",
    transform: "translate(2.72 10.24)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#577596",
      strokeMiterlimit: 10
    },
    d: "M0 0h6.403"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemNumberIcon);
export default __webpack_public_path__ + "static/media/item-number-icon.dd806e345bd950b9321f7c9e1192c53e.svg";
export { ForwardRef as ReactComponent };